var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useProfileContext } from '@marketing/profile/ProfileContext';
import AddAnotherDogInput from '@marketing/profile/common/AddAnotherDogInput';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { useState } from 'react';
import { useNavigate } from 'react-router';
var AddAnotherDogForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), addPet = _a.addPet, currentPetIndex = _a.currentPetIndex, profileBasePath = _a.profileBasePath, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var _b = useState(''), addAnother = _b[0], setAddAnother = _b[1];
    var handleOptionChange = function (e) {
        setAddAnother(e.target.value);
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/meals"), { viewTransition: true });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        sendFunnelGTMEvent('click-next_additional_pets');
        if (addAnother === 'yes') {
            addPet();
            navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex + 1, "/name"), { viewTransition: true });
        }
        else {
            navigate("".concat(profileBasePath, "/addons"), { viewTransition: true });
        }
    };
    var formId = 'add-another-dog-form';
    return (_jsx(ProfileFormLayout, __assign({ disableNext: !addAnother, formId: formId, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Add another dog", widthClassName: "w-full md:max-w-md" }, { children: _jsx("form", __assign({ id: formId, onSubmit: handleSubmit }, { children: _jsx(AddAnotherDogInput, { addAnother: addAnother, handleOptionChange: handleOptionChange }) })) })) })));
};
export default AddAnotherDogForm;
